import { createGenericSlice } from './generic.slice'
import { RootState } from '@store/store'

export interface ArticleVersionModel {
  id: string
  article: string
  dateModified: string
  text: string
  downloadAt: string
  downloadBy: string
  perex: string
}

const {
  slice: articleVersionSlice,
  thunks: articleVersionThunks,
  adapter: articleVersionAdapter,
} = createGenericSlice<ArticleVersionModel>(
  'ArticleVersion',
  'articleVersions',
  {} // Initial state can be customized if needed
)

export const {
  // selectAll: selectAllArticleVersions,
  // selectById: selectArticleVersionById,
  // ... other selectors
} = articleVersionAdapter.getSelectors<RootState>(
  (state: RootState) => state.articleVersions
)

export const {
  // fetchAll: fetchAllArticleVersions,
  // fetchById: fetchArticleVersionById,
  // create: createArticleVersion,
  // update: updateArticleVersion,
  // delete: deleteArticleVersion,
} = articleVersionThunks

export default articleVersionSlice.reducer
